import * as React from "react";

function SortArrow(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 15 12" fill="none" {...props}>
      <path
        d="M7.467 3.3l-.943.943-1.69-1.691v8.781H3.5V2.552l-1.69 1.69L.867 3.3l3.3-3.3 3.3 3.3zm6.666 5.4l-3.3 3.3-3.3-3.3.943-.943 1.691 1.691V.667H11.5v8.781l1.69-1.69.943.942z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoSortArrow = React.memo(SortArrow);
export default MemoSortArrow;
